// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page-specific styles for ProductDetails */

/* Catalog and details */
.filter-scroll,
.tabs {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  margin-bottom: 1.5rem;
  padding-bottom: 0.4rem;
  scrollbar-width: none;
}
.filter-scroll button,
.tabs button {
  white-space: nowrap;
  border: 1px solid var(--line);
  border-radius: 50px;
  padding: 0.65rem 1rem;
  color: var(--muted);
  background: var(--paper);
  font-size: 0.85rem;
  font-weight: 700;
}
.filter-scroll button.active,
.tabs button.active {
  color: white;
  background: var(--green-800);
  border-color: var(--green-800);
}
.product-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
  transition:
    transform 0.2s,
    box-shadow 0.2s;
}
.product-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow);
}
.product-image {
  display: block;
  height: 230px;
  overflow: hidden;
  position: relative;
}
.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s;
}
.product-card:hover img {
  transform: scale(1.03);
}
.price-pill {
  position: absolute;
  top: 1rem;
  right: 1rem;
  padding: 0.5rem 0.75rem;
  border-radius: 50px;
  color: var(--green-950);
  background: var(--yellow);
  font-weight: 800;
}
.product-card h3 {
  font-family: var(--font-serif);
  font-size: 1.4rem;
}
.nutrition-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--line);
  color: var(--green-800);
  font-size: 0.78rem;
  font-weight: 700;
}
.nutrition-disclaimer {
  margin-top: 1.5rem;
  color: var(--muted);
  font-size: 0.75rem;
}
.market-banner {
  min-height: 360px;
  display: flex;
  align-items: end;
  overflow: hidden;
  margin-bottom: 4rem;
  border-radius: var(--radius);
  position: relative;
}
.market-banner img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.market-banner::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(transparent 5%, rgba(18, 55, 42, 0.9));
}
.market-banner div {
  position: relative;
  z-index: 1;
  padding: 1.5rem;
  color: white;
}
.market-banner .eyebrow {
  color: var(--yellow);
}
.market-banner h2 {
  font-size: clamp(1.9rem, 4vw, 3.2rem);
  max-width: 800px;
}
.build-basket {
  margin-top: 2rem;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--green-50);
}
.build-basket p {
  color: var(--muted);
  max-width: 700px;
}
.detail-grid {
  display: grid;
  gap: 2rem;
}
.detail-image {
  min-height: 420px;
  position: relative;
}
.detail-image img {
  width: 100%;
  height: 100%;
  max-height: 650px;
  object-fit: cover;
  border-radius: var(--radius);
}
.detail-image .back {
  position: absolute;
  z-index: 1;
  top: 1rem;
  left: 1rem;
}
.detail-copy h1 {
  margin: 0.5rem 0;
  font-size: clamp(2.5rem, 6vw, 4.6rem);
  line-height: 0.95;
}
.detail-copy .lead {
  color: var(--muted);
}
.detail-price {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin: 1rem 0;
}
.detail-price strong {
  font-family: var(--font-serif);
  font-size: 2rem;
}
.detail-price span {
  color: var(--muted);
}
.nutrition-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.65rem;
  margin: 0.7rem 0 0.7rem;
}
.nutrition-grid div {
  padding: 1rem;
  border-radius: 14px;
  background: var(--green-50);
}
.nutrition-grid span,
.nutrition-grid strong {
  display: block;
}
.nutrition-grid span {
  color: var(--muted);
  font-size: 0.72rem;
}
.ingredient-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0.8rem 0 1.5rem;
}
.ingredient-list span {
  padding: 0.55rem 0.75rem;
  border: 1px solid var(--line);
  border-radius: 50px;
  font-size: 0.82rem;
  font-weight: 600;
}
.ingredient-list i {
  color: var(--green-700);
  margin-right: 0.4rem;
}
.fresh-note,
.service-note {
  display: flex;
  gap: 0.8rem;
  padding: 1rem;
  border-radius: 14px;
  background: var(--green-50);
  color: var(--green-950);
}
.fresh-note {
  margin: 1.25rem 0;
}
.fresh-note i,
.service-note i {
  color: var(--green-700);
  margin-top: 0.2rem;
}
.fresh-note p {
  margin: 0.2rem 0 0;
  color: var(--muted);
  font-size: 0.82rem;
}

.fruit-basket-tc {
  padding: 10px;
  background: var(--green-50);
}

@media (min-width: 768px) {
  .detail-grid {
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
  .detail-image {
    position: sticky;
    top: 96px;
    height: calc(100vh - 130px);
  }
  .detail-copy {
    padding: 2rem 0;
  }
  .nutrition-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* Custom fruit basket selection */
.fruit-picker {
  padding: 1.1rem;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
}
.fruit-picker-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}
.fruit-picker-heading h3 {
  margin: 0;
  font-size: 1.25rem;
}
.fruit-picker-heading > span {
  color: var(--green-800);
  font-size: 0.8rem;
  font-weight: 800;
  white-space: nowrap;
}
.fruit-picker-help {
  display: block;
  margin: 0.55rem 0 1rem;
  color: var(--muted);
  font-size: 0.85rem;
}
.fruit-picker-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
}
.fruit-option {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  min-width: 0;
  padding: 0.75rem;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--paper);
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 650;
}
.fruit-option.selected {
  border-color: var(--green-700);
  background: var(--green-50);
  color: var(--green-950);
}
.fruit-option input {
  accent-color: var(--green-800);
  flex: 0 0 auto;
}
.fruit-option span {
  flex: 1;
}
.fruit-option > i {
  color: var(--green-700);
}
.fruit-option:has(input:disabled:not(:checked)) {
  opacity: 0.5;
  cursor: not-allowed;
}
@media (max-width: 420px) {
  .fruit-picker-options {
    grid-template-columns: 1fr;
  }
}


/* Live whole-fruit weight estimate shown below the basket selector. */
.fruit-weight-estimate {
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid #cfe5d8;
  border-radius: 14px;
  background: #f2faf5;
  color: var(--green-950);
}
.fruit-weight-estimate-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .75rem;
  flex-wrap: wrap;
}
.fruit-weight-estimate-heading strong { font-size: .98rem; }
.fruit-weight-estimate-heading span {
  padding: .25rem .6rem;
  border-radius: 999px;
  background: #dcefe3;
  font-size: .8rem;
  font-weight: 800;
}
.fruit-weight-estimate p {
  margin: .45rem 0 .65rem;
  color: var(--muted);
  font-size: .82rem;
}
.fruit-weight-estimate ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: .45rem .75rem;
}
.fruit-weight-estimate li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: .5rem;
  padding: .55rem .65rem;
  border-radius: 9px;
  background: #fff;
  font-size: .86rem;
}
.fruit-weight-estimate li strong { white-space: nowrap; }
.fruit-weight-estimate > small {
  display: block;
  margin-top: .65rem;
  color: var(--muted);
  font-size: .74rem;
}
.fruit-weight-alert {
  margin-top: 1rem;
  padding: .9rem 1rem;
  border: 1px solid #f1b6ac;
  border-radius: 12px;
  background: #fff2ef;
  color: #922d20;
  font-size: .88rem;
  font-weight: 650;
}
@media (max-width: 420px) {
  .fruit-weight-estimate ul { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/css/ProductDetails.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C,wBAAwB;AACxB;;EAEE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;EACxB;;mBAEiB;AACnB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kEAAkE;AACpE;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;AACA;;EAEE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,OAAO;AACT;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;;AAGA,sEAAsE;AACtE;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;AACA,wCAAwC,iBAAiB,EAAE;AAC3D;EACE,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,gDAAgD;EAChD,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA,mCAAmC,mBAAmB,EAAE;AACxD;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,4BAA4B,0BAA0B,EAAE;AAC1D","sourcesContent":["/* Page-specific styles for ProductDetails */\n\n/* Catalog and details */\n.filter-scroll,\n.tabs {\n  display: flex;\n  gap: 0.5rem;\n  overflow-x: auto;\n  margin-bottom: 1.5rem;\n  padding-bottom: 0.4rem;\n  scrollbar-width: none;\n}\n.filter-scroll button,\n.tabs button {\n  white-space: nowrap;\n  border: 1px solid var(--line);\n  border-radius: 50px;\n  padding: 0.65rem 1rem;\n  color: var(--muted);\n  background: var(--paper);\n  font-size: 0.85rem;\n  font-weight: 700;\n}\n.filter-scroll button.active,\n.tabs button.active {\n  color: white;\n  background: var(--green-800);\n  border-color: var(--green-800);\n}\n.product-card {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n  transition:\n    transform 0.2s,\n    box-shadow 0.2s;\n}\n.product-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow);\n}\n.product-image {\n  display: block;\n  height: 230px;\n  overflow: hidden;\n  position: relative;\n}\n.product-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.4s;\n}\n.product-card:hover img {\n  transform: scale(1.03);\n}\n.price-pill {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: 50px;\n  color: var(--green-950);\n  background: var(--yellow);\n  font-weight: 800;\n}\n.product-card h3 {\n  font-family: var(--font-serif);\n  font-size: 1.4rem;\n}\n.nutrition-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--line);\n  color: var(--green-800);\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n.nutrition-disclaimer {\n  margin-top: 1.5rem;\n  color: var(--muted);\n  font-size: 0.75rem;\n}\n.market-banner {\n  min-height: 360px;\n  display: flex;\n  align-items: end;\n  overflow: hidden;\n  margin-bottom: 4rem;\n  border-radius: var(--radius);\n  position: relative;\n}\n.market-banner img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.market-banner::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(transparent 5%, rgba(18, 55, 42, 0.9));\n}\n.market-banner div {\n  position: relative;\n  z-index: 1;\n  padding: 1.5rem;\n  color: white;\n}\n.market-banner .eyebrow {\n  color: var(--yellow);\n}\n.market-banner h2 {\n  font-size: clamp(1.9rem, 4vw, 3.2rem);\n  max-width: 800px;\n}\n.build-basket {\n  margin-top: 2rem;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: flex-start;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--green-50);\n}\n.build-basket p {\n  color: var(--muted);\n  max-width: 700px;\n}\n.detail-grid {\n  display: grid;\n  gap: 2rem;\n}\n.detail-image {\n  min-height: 420px;\n  position: relative;\n}\n.detail-image img {\n  width: 100%;\n  height: 100%;\n  max-height: 650px;\n  object-fit: cover;\n  border-radius: var(--radius);\n}\n.detail-image .back {\n  position: absolute;\n  z-index: 1;\n  top: 1rem;\n  left: 1rem;\n}\n.detail-copy h1 {\n  margin: 0.5rem 0;\n  font-size: clamp(2.5rem, 6vw, 4.6rem);\n  line-height: 0.95;\n}\n.detail-copy .lead {\n  color: var(--muted);\n}\n.detail-price {\n  display: flex;\n  align-items: baseline;\n  gap: 0.5rem;\n  margin: 1rem 0;\n}\n.detail-price strong {\n  font-family: var(--font-serif);\n  font-size: 2rem;\n}\n.detail-price span {\n  color: var(--muted);\n}\n.nutrition-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.65rem;\n  margin: 0.7rem 0 0.7rem;\n}\n.nutrition-grid div {\n  padding: 1rem;\n  border-radius: 14px;\n  background: var(--green-50);\n}\n.nutrition-grid span,\n.nutrition-grid strong {\n  display: block;\n}\n.nutrition-grid span {\n  color: var(--muted);\n  font-size: 0.72rem;\n}\n.ingredient-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin: 0.8rem 0 1.5rem;\n}\n.ingredient-list span {\n  padding: 0.55rem 0.75rem;\n  border: 1px solid var(--line);\n  border-radius: 50px;\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n.ingredient-list i {\n  color: var(--green-700);\n  margin-right: 0.4rem;\n}\n.fresh-note,\n.service-note {\n  display: flex;\n  gap: 0.8rem;\n  padding: 1rem;\n  border-radius: 14px;\n  background: var(--green-50);\n  color: var(--green-950);\n}\n.fresh-note {\n  margin: 1.25rem 0;\n}\n.fresh-note i,\n.service-note i {\n  color: var(--green-700);\n  margin-top: 0.2rem;\n}\n.fresh-note p {\n  margin: 0.2rem 0 0;\n  color: var(--muted);\n  font-size: 0.82rem;\n}\n\n.fruit-basket-tc {\n  padding: 10px;\n  background: var(--green-50);\n}\n\n@media (min-width: 768px) {\n  .detail-grid {\n    grid-template-columns: 1fr 1fr;\n    align-items: start;\n  }\n  .detail-image {\n    position: sticky;\n    top: 96px;\n    height: calc(100vh - 130px);\n  }\n  .detail-copy {\n    padding: 2rem 0;\n  }\n  .nutrition-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n/* Custom fruit basket selection */\n.fruit-picker {\n  padding: 1.1rem;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.fruit-picker-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n.fruit-picker-heading h3 {\n  margin: 0;\n  font-size: 1.25rem;\n}\n.fruit-picker-heading > span {\n  color: var(--green-800);\n  font-size: 0.8rem;\n  font-weight: 800;\n  white-space: nowrap;\n}\n.fruit-picker-help {\n  display: block;\n  margin: 0.55rem 0 1rem;\n  color: var(--muted);\n  font-size: 0.85rem;\n}\n.fruit-picker-options {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.65rem;\n}\n.fruit-option {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  min-width: 0;\n  padding: 0.75rem;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  background: var(--paper);\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 650;\n}\n.fruit-option.selected {\n  border-color: var(--green-700);\n  background: var(--green-50);\n  color: var(--green-950);\n}\n.fruit-option input {\n  accent-color: var(--green-800);\n  flex: 0 0 auto;\n}\n.fruit-option span {\n  flex: 1;\n}\n.fruit-option > i {\n  color: var(--green-700);\n}\n.fruit-option:has(input:disabled:not(:checked)) {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n@media (max-width: 420px) {\n  .fruit-picker-options {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n/* Live whole-fruit weight estimate shown below the basket selector. */\n.fruit-weight-estimate {\n  margin-top: 1rem;\n  padding: 1rem;\n  border: 1px solid #cfe5d8;\n  border-radius: 14px;\n  background: #f2faf5;\n  color: var(--green-950);\n}\n.fruit-weight-estimate-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: .75rem;\n  flex-wrap: wrap;\n}\n.fruit-weight-estimate-heading strong { font-size: .98rem; }\n.fruit-weight-estimate-heading span {\n  padding: .25rem .6rem;\n  border-radius: 999px;\n  background: #dcefe3;\n  font-size: .8rem;\n  font-weight: 800;\n}\n.fruit-weight-estimate p {\n  margin: .45rem 0 .65rem;\n  color: var(--muted);\n  font-size: .82rem;\n}\n.fruit-weight-estimate ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: .45rem .75rem;\n}\n.fruit-weight-estimate li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: .5rem;\n  padding: .55rem .65rem;\n  border-radius: 9px;\n  background: #fff;\n  font-size: .86rem;\n}\n.fruit-weight-estimate li strong { white-space: nowrap; }\n.fruit-weight-estimate > small {\n  display: block;\n  margin-top: .65rem;\n  color: var(--muted);\n  font-size: .74rem;\n}\n.fruit-weight-alert {\n  margin-top: 1rem;\n  padding: .9rem 1rem;\n  border: 1px solid #f1b6ac;\n  border-radius: 12px;\n  background: #fff2ef;\n  color: #922d20;\n  font-size: .88rem;\n  font-weight: 650;\n}\n@media (max-width: 420px) {\n  .fruit-weight-estimate ul { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
